import React from "react";

import AddIcon from "@mui/icons-material/Add";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import {
  TaskDetailsV2,
  TaskDetailsV3,
  TaskStatus,
} from "@fartherfinance/frontend/api/Tasks/Types";

import { useTasksNavigation } from "../../../hooks";
import TaskProgressChip from "../../../TaskProgressIndicator/TaskProgressChip";
import TaskStatusIcon from "../../../TaskStatusIcon/TaskStatusIcon";
import Button from "@src/multiCustodian/components/MUI/Button/Button";
import IconButton from "@src/sharedComponents/IconButton/IconButton";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./TaskSubtasks.module.css";

interface TaskSubtasksProps {
  taskDetails: TaskDetailsV2 | TaskDetailsV3;
}

const TaskSubtasks: React.FC<TaskSubtasksProps> = ({ taskDetails }) => {
  const { handleNavigateToTaskDetails, handleNavigateToSubtaskCreation } =
    useTasksNavigation();

  const subtasks = taskDetails?.children?.tasks ?? [];

  if (subtasks.length === 0) {
    return (
      <Button
        variant="text"
        buttonType="primary"
        style={{ justifyContent: "unset" }}
        text="Create Subtask"
        startIcon={<AddIcon className={styles.createIcon} />}
        onClick={() => handleNavigateToSubtaskCreation(taskDetails)}
      />
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.title}>
          <Text variant="title3">Subtasks</Text>
          <TaskProgressChip variant="counter-and-label" subtasks={subtasks} />
        </div>

        <IconButton
          size="small"
          iconClassName={styles.icon}
          onClick={() => handleNavigateToSubtaskCreation(taskDetails)}
          IconComponent={AddIcon}
        />
      </div>

      <div>
        {subtasks.map((subtask) => (
          <div
            key={subtask.id}
            className={styles.subtask}
            onClick={() => handleNavigateToTaskDetails(subtask.id)}
          >
            <div className={styles.subtaskDetails}>
              <TaskStatusIcon taskStatus={subtask.taskStatus} />

              {subtask.taskStatus !== TaskStatus.enum.CANCELED ? (
                <Text variant="body">{subtask.title}</Text>
              ) : (
                <Text variant="body" color="textSubtle">
                  {subtask.title} - Canceled
                </Text>
              )}
            </div>

            <IconButton
              size="small"
              iconClassName={styles.icon}
              onClick={() => handleNavigateToTaskDetails(subtask.id)}
              IconComponent={ChevronRightIcon}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default TaskSubtasks;
